export default __webpack_public_path__ + "static/electrical_motor_b.aa5da9a65768c3c8ad92a147d402ea0b.png";